import type { Point } from '@view-model/models/common/basic/Point';

export class Line {
  constructor(
    public readonly p1: Point,
    public readonly p2: Point
  ) {}
}
